import { isNonEmptyArray, isNonEmptyString } from "@cayuse/shared-react.utils.type-checks";
import Helper from "components/FormResponse/helper";
import { MAX_FILE_SIZE } from "globals/constants";

export const transformAttachmentDisplay = str => { // todo: abstract and share this w/ awards
	let splitArray = isNonEmptyString(str)
		? str.split("}")
		: [];

	if (isNonEmptyArray(splitArray)) {
		let nameArray = [];
		splitArray.forEach(str => {
			let result = str.match(/name=([^,]+)/);
			if (isNonEmptyArray(result)) {
				nameArray.push(result[1]);
			}
		});

		return nameArray.join(", ");
	}
};

export const validateAttachments = (payloadContent) => {
	let valid = true;
	for(let prop in payloadContent) {
		const value = payloadContent[prop];
		if(value instanceof Array) {
			for(let i = 0; i < value.length; i++) {
				if (value[i].fileData?.size > MAX_FILE_SIZE) {
					payloadContent[prop].splice(i, 1);
					Helper.formRef.setPayload(prop, payloadContent[prop]);
					valid = false;
				}
			}
		}
	}

	return valid;
}